/**
 * @generated SignedSource<<3672ee220b87bb17a0e192db067cad54>>
 * @relayHash 6366c8000c0010152c94270690f8db12
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7d255021c81715a7d8d630e3b29c982ae24b4ffe9e28fcc0e71c47aed8f5c753

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ImageContentType = "GIF" | "JPEG" | "PNG" | "WEBP" | "%future added value";
export type ImageOwnerType = "EVENTS" | "GUILDS" | "GUILD_NETWORKS" | "GUILD_SPONSORSHIPS" | "POSTS" | "USERS" | "VENUES" | "%future added value";
export type CreateImageInput = {
  contentType: ImageContentType;
  height?: number | null | undefined;
  ownerId: string;
  ownerType: ImageOwnerType;
  width?: number | null | undefined;
};
export type FormImageUploadMutation$variables = {
  input: CreateImageInput;
};
export type FormImageUploadMutation$data = {
  readonly createImage: {
    readonly image: {
      readonly rowId: string;
      readonly url: string;
    } | null | undefined;
    readonly uploadURL: string | null | undefined;
  };
};
export type FormImageUploadMutation = {
  response: FormImageUploadMutation$data;
  variables: FormImageUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadURL",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormImageUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateImagePayload",
        "kind": "LinkedField",
        "name": "createImage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormImageUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateImagePayload",
        "kind": "LinkedField",
        "name": "createImage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "7d255021c81715a7d8d630e3b29c982ae24b4ffe9e28fcc0e71c47aed8f5c753",
    "metadata": {},
    "name": "FormImageUploadMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b23a716750077e5f7e1662ef64e49a53";

export default node;
